import { MultiSelectFilter } from '@components/Filters/MultiSelectFilter';
import { SearchFilterDebounced } from '@components/Filters/SearchFilterDebounced';
import { SelectFilter } from '@components/Filters/SelectFilter';
import styles from './OutboundCallerIdTableFilters.module.css';
import { useOutboundCallerIdTableContext } from '@components/OutboundCallerIdSelection/context';
import { ClearFilters } from '@components/Filters/ClearFilters';
import { NAMED_FILTER_OPTIONS } from '../hooks/useOutboundCallerIdFilters';
import { Chip } from '@servicetitan/anvil2';
import maskPhoneNumber from '@lib/utils/maskPhoneNumber';

export const OutboundCallerIdTableFilters = () => {
  const {
    areaCodesOptions,
    filters,
    table: { selectedItem },
    loading,
  } = useOutboundCallerIdTableContext();

  const {
    value,
    areaCodes,
    namedFilter,
    onValueChange,
    onNamedFilterChange,
    onAreaCodesChange,
    hasFilters,
    onClear,
  } = filters;

  return (
    <div className={styles.filtersContainer}>
      <SearchFilterDebounced
        value={value}
        onChange={(v) => onValueChange(v)}
        placeholder='Search by campaign, name, or phone number'
        className='w-100'
        disabled={loading}
      />
      <div className={styles.filters}>
        <SelectFilter
          name='Type'
          value={namedFilter}
          options={NAMED_FILTER_OPTIONS}
          onChange={(value) => onNamedFilterChange(value)}
          className={styles.namesFilter}
          disabled={loading}
        />
        {areaCodesOptions.length > 0 && (
          <MultiSelectFilter
            name='Area Code'
            value={areaCodes}
            options={areaCodesOptions.map((code) => ({
              value: code,
              name: code,
            }))}
            onChange={(data) => onAreaCodesChange(data)}
            disabled={loading}
          />
        )}
        {hasFilters() && <ClearFilters onClear={onClear} />}
        {selectedItem && (
          <Chip
            label={`Selected: ${selectedItem.name || maskPhoneNumber(selectedItem.number)}`}
            className={styles.selectedItemChip}
          />
        )}
      </div>
    </div>
  );
};
